import MeetupFormPage from '@/pages/admin/MeetupFormPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/meetup/create')({
  component: RouteComponent,
});

function RouteComponent() {
  return <MeetupFormPage />;
}
